import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  state: {
    showBuildingsModal: false,

    deleteBuilding: {
      id: null,
      info: ''
    },

    buildingToEdit: null,

    showAccountModal: false,

    showDeclarationModal: false,

    currentUserData: {},

    declarationBuilding: {},
    declarationEditId: null,

    declarationsListTrigger: false,

    declarationHistoryId: null,
    showHistoryModal: false,

    declarationVerification: null,
    declarationVerificationFull: null,

    clonedDeclarationId: null,
    showCloneDeclarationModal: false,
    clonedDeclarationFinalId: null,

    cachedBuildingData: null,

    movedDeclarationId: null,
    showMoveDeclarationModal: false
  },
  mutations: {
    updateDeclarationsList(state) {
      state.declarationsListTrigger = !state.declarationsListTrigger;
    },

    setDeclarationBuilding(state, buildingData) {
      state.declarationBuilding = buildingData;
    },

    openDeclarationModal(state) {
      state.showDeclarationModal = true;
    },
    setDeclarationEditId(state, id) {
      state.declarationEditId = id;
    },
    closeDeclarationModal(state) {
      state.declarationEditId = null;
      state.showDeclarationModal = false;
    },
    openBuildingsModal(state) {
      state.showBuildingsModal = true;
    },
    closeBuildingModal(state) {
      state.buildingToEdit = null;
      state.showBuildingsModal = false;
    },
    openAccountModal(state) {
      state.showAccountModal = true;
    },
    closeAccountModal(state) {
      state.showAccountModal = false;
    },
    /**
     * Set data which will be used in DeleteBuildingModal later
     * @param state
     * @param data id: int, info: str
     */
    setDeleteBuildingData(state, data) {
      state.deleteBuilding = data;
    },
    setBuildingToEdit(state, data) {
      state.buildingToEdit = data;
    },

    setCurrentUserData(state, userData) {
      state.currentUserData = userData;
    },

    setDeclarationHistoryId(state, id) {
      state.declarationHistoryId = id;
    },
    openHistoryModal(state) {
      state.showHistoryModal = true;
    },
    closeHistoryModal(state) {
      state.declarationHistoryId = null;
      state.showHistoryModal = false;
    },
    setDeclarationVerification(state, v) {
      state.declarationVerification = v;
    },
    setDeclarationVerificationFull(state, v) {
      state.declarationVerificationFull = v;
    },

    setClonedDeclarationId(state, id) {
      state.clonedDeclarationId = id;
    },
    openCloneDeclarationModal(state) {
      state.showCloneDeclarationModal = true;
    },
    closeCloneDeclarationModal(state) {
      state.clonedDeclarationId = null;
      state.showCloneDeclarationModal = false;
    },
    setDeclarationClonedFinalId(state, id) {
      state.clonedDeclarationFinalId = id;
    },
    resetDeclarationClonedFinalId(state) {
      state.clonedDeclarationFinalId = null;
    },

    setCachedBuildingData(state, v) {
      state.cachedBuildingData = v;
    },

    setMovedDeclarationId(state, id) {
      state.movedDeclarationId = id;
    },
    openMoveDeclarationModal(state) {
      state.showMoveDeclarationModal = true;
    },
    closeMoveDeclarationModal(state) {
      state.movedDeclarationId = null;
      state.showMoveDeclarationModal = false;
    }
  },
  actions: {}
})

export default store
